import Toast from '../../../client/toast.js'

export default class Cart
{
	static count(form, count_field, price, price_field, identifier, plus)
	{
		form = document.querySelector(form)
		const count = Number(form.count.value) + (plus ? 1 : -1)

		if(count < 1) return
		const data = new FormData(form)

		data.set('__action', 'count')
		data.set('plus', plus ? '1' : '0')

		$.ajax({
			url : '/cart/',
			type: 'POST',

			processData: false,
			contentType: false,

			data   : data,
			success: (data) =>
			{
				if(data.success)
				{
					Toast.success(data.message)

					$(count_field).text(count)
					form.count.value = count

					$(price_field).text((price * count).toLocaleString())
				}
				else
				{
					Toast.warning(data.message)
				}
			},
		})
	}

	static remove(cart, name)
	{
		name = name.trim()
		if(!confirm(`${name}をカートから削除してよろしいですか？`)) return

		const data = new FormData()

		data.set('__action', 'remove')
		data.set('cart', cart)

		$.ajax({
			url : '/cart/',
			type: 'POST',

			processData: false,
			contentType: false,

			data   : data,
			success: (data) =>
			{
				if(data.success)
				{
					Toast.success(data.message)
					$(`#row_${cart}`).remove()

					if($('#form input').length === 0) setTimeout(() => location.reload(), 2000)
				}
				else Toast.warning(data.message)
			},
		})
	}
}
